import { RouterStateSnapshot } from '@angular/router';

import { RouterStateSerializer } from '@ngrx/router-store';

export interface RouterStateUrl {
	url: string;
}

export class CustomRouteStateSerializer implements RouterStateSerializer<RouterStateUrl> {
	serialize(routerState: RouterStateSnapshot): RouterStateUrl {
		const { url } = routerState;

		// Only return an object including the URL
		// instead of the entire snapshot
		return { url };
	}
}



// WEBPACK FOOTER //
// ./src/app/shared/state-management/custom-route-state-serializer.ts